import EventBus from "@/uitls/EventBus";
import { imMessageListModel, imChatModel, imUserModel, imFriendListModel, imGroupListModel } from "@/model/chatModel";
import Storage from "@/uitls/Storage"; 
import Dexie, { Table } from 'dexie';

class DBTable extends Dexie {
    public imlist!: Table<imMessageListModel, string>; // id is number in this case
    public imchat!: Table<imChatModel, number>;
    public imuser!: Table<imUserModel, number>;
    public imfriend!: Table<imFriendListModel, number>;
    public imgroup!: Table<imGroupListModel, number>;

    public constructor() {
        super(Storage.get('uid'));
        this.version(6).stores({
            imlist: "chatkey,chatmsgno,[chatkey+chatmsgno],isGroup,uid,content,fid,headurl,nickname,time,red,msgtype",
            imchat: "++id,chatkey,chatmsgno,[chatkey+chatmsgno],uid,content,headurl,nickname,phonenum,time,msgtype,clientkey,read",
            imuser: "uid,fid,headurl,nickname,phonenum,lastlogouttime",
            imfriend: "uid,fid,lastlogouttime,headurl,phonenum,nickname,type",
            imgroup: "groupkey,chatkey,headurl,nickname,groupnotify,isforbid,chatmsgno,attrversion,grouphost,groupadmins,admins,info_limits,add_limits,look_limits,member_cnt,send_msg_limits,notifyversion,forbidbegintm,forbidendtm,online_cnt",
        });
    }
}

interface DB {
    db: DBTable,
    init: () => any,
    open: boolean
}

const indexDB: DB = {
    db: null,
    open: false,
    init: async () => {
        try {
            const db = new DBTable();
            await db.open();
            indexDB.db = db;
            indexDB.open = true;
            EventBus.emit("dbOnsuccess");
            
        } catch (error) {
            console.log('数据库开启失败error=',error);
        }
    },

}

export default indexDB